import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { getToken } from "../../utils/getToken";

export const useGetInventoryHistoryQuery = (id: any) => {
  const token = getToken();

  return useQuery({
    queryKey: ["getInventoryHistory", id],
    queryFn: () =>
      axiosInstance
        .get(`/inventories/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),

    // onError: (error: any) => {
    //   message.error(error?.response?.data?.message || 'An error occurred');
    //   console.error('Error fetching inventory history:', error);
    // },
    enabled: !!token,
  });
};
